import { BaseRouteService } from 'core/services';

class CorporateRouteService extends BaseRouteService {
    constructor() {
        super('corporates');
    }

    find(filter) {
        return super.find(this.base + '/{?isActive,searchQuery,page,rpp,sort,embed,fields,isNiko}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    downloadContacts(filter) {
        return super.find(this.base + '/download-contacts/{?searchQuery,sort,isActive,isNiko}', filter);
    }
}

export default CorporateRouteService;
